module.exports = __webpack_public_path__ + "media/images/donations/discover-74698f9c671e846c70f9d479ca0f3d56.png";